import React, { useContext } from 'react'
import { MetricsContext } from '../context'
import { Card, CardContent } from '../../../components/layout/Card'
import SafeRetirementTextIndicator from '../../../safe_retirement/SafeRetirementTextIndicator'
import SafeRetirementBar from '../../../safe_retirement/SafeRetirementBar'
import Box from '@material-ui/core/Box'

export const SafeRetirementStatus = () => {
  const { state } = useContext(MetricsContext)
  const { safeRetirementStatus } = state
  const { percentage, text } = safeRetirementStatus
  return (
    <Card className='safe-retirement-status'>
      <SafeRetirementTextIndicator
        percentage={percentage}
        text={text}
      />
      <SafeRetirementBar
        percentage={percentage}
        width={800}
      />
      <CardContent>
        <SafeRetirementStatusBuckets />
      </CardContent>
    </Card>
  )
}

const SafeRetirementStatusBuckets = () => {
  const { state } = useContext(MetricsContext)
  const { safeRetirementStatusLabels, safeRetirementStatus } = state
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      m='1rem'
    >
      {Object.keys(safeRetirementStatusLabels).reverse().map(key =>
        <Bucket
          key={key}
          label={safeRetirementStatusLabels[key]}
          value={safeRetirementStatus.brackets[key]}
        />
      )}
    </Box>
  )
}

const Bucket = ({ label, value }) =>
  <div>
    <p>{label}</p>
    <h2 className='h6'> {value}% </h2>
  </div>
